import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { isNullOrUndefined } from "@utils/object-util";

export const sendVerificationMessageRequest = async (
    templateId: string,
    selectedLanguage: string,
    recipient: string,
    rpServiceId: string,
    selectedIdp: string,
    selectedCountry: string,
    selectedRedirectTo: string,
    credential: string,
    asi: string,
    appId: string,
    attributeTypeToFieldValueMap: { [id: string]: { [id: string]: string } },
    canModifySelfServiceVerificationExpiration: boolean,
    loginHintExpirationType: string,
    loginHintExpirationValue: string
) => {
    const route = apiRoutes.serviceConfiguration.selfService.send;
    const attributeTypeFieldValues: { [id: string]: string } = {};
    Object.values(attributeTypeToFieldValueMap).forEach(attributeFieldValueMap => {
        Object.entries(attributeFieldValueMap).forEach(([key, value]) => {
            attributeTypeFieldValues[key] = value;
        });
    });

    const additionalBody = (!(isNullOrUndefined(loginHintExpirationValue) || loginHintExpirationValue === "") && canModifySelfServiceVerificationExpiration)
        ? { expiration: { type: loginHintExpirationType, value: loginHintExpirationValue } }
        : {};

    const body = {
        templateID: templateId,
        language: selectedLanguage,
        recipients: [recipient],
        rpServiceID: rpServiceId,
        appID: appId,
        attributes: attributeTypeFieldValues,
        IDP: selectedIdp,
        country: selectedCountry,
        callbackURL: selectedRedirectTo,
        credential: credential,
        asi: asi,
        ...additionalBody

    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    // if (data?.code === 200) {
    //     return data;
    // }

    return { data, error, body };
};